import { Controller } from "@hotwired/stimulus"
import { track } from "../lib/umami"
import { observeOnce } from "../lib/observe_once"
import { trackOnConnect } from "../lib/track_on_connect"
import { trackProps } from "../lib/track_props"

export default class extends Controller {
  static values = {
    event: String,
    props: { type: Object, default: {} },
    // Évènement sans clic : émis à l'apparition de l'élément (ex. match débloqué
    // par un crédit, tracé une seule fois à l'ouverture de la fiche).
    fireOnConnect: { type: Boolean, default: false },
    // Évènement « section vue » : émis une seule fois, au premier passage de
    // l'élément dans la zone visible (pas de répétition au scroll).
    fireOnVisible: { type: Boolean, default: false },
    // Case à cocher : ajoute `checked` aux props (cf. lib/track_props.js).
    withChecked: { type: Boolean, default: false },
    // <select> : ajoute la valeur choisie (`value`) aux props (cf. lib/track_props.js).
    withValue: { type: Boolean, default: false }
  }

  connect() {
    this.stopObserving = trackOnConnect({
      element: this.element,
      fireOnConnect: this.fireOnConnectValue,
      fireOnVisible: this.fireOnVisibleValue,
      fire: () => this.fire(),
      observe: observeOnce
    })
  }

  disconnect() {
    this.stopObserving?.()
  }

  // Un même clic peut devoir tracer plusieurs évènements distincts (ex. "plan
  // sélectionné" + "checkout démarré" sur le même CTA) —
  // séparateur "|", rétrocompatible avec un event_value simple.
  fire(event) {
    if (!this.eventValue) return
    // <summary> d'un <details> : le même clic ouvre et ferme, seule l'ouverture est
    // tracée. Au clic, `open` donne encore l'état d'avant le basculement.
    if (event?.currentTarget?.tagName === "SUMMARY" && event.currentTarget.parentElement?.open) return
    const props = trackProps(this.propsValue, event, this.withCheckedValue, this.withValueValue)
    this.eventValue.split("|").forEach(name => track(name, props))
  }
}
